import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertDialogComponent } from './alert-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class AlertDialogService {
    isOfflineAlertOpen: boolean = false;
    timeoutWarningModalRef: NgbModalRef | null = null;

    constructor(private modalService: NgbModal) { }

    public showAlert(
        title: string,
        message: string,
        btnOkText: string = 'OK',
        dialogSize: 'sm' | 'lg' = 'sm',
        centered: boolean = true
    ): Promise<boolean> {
        const modalRef = this.modalService.open(AlertDialogComponent, { size: dialogSize, centered: centered });
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.message = message;
        modalRef.componentInstance.btnOkText = btnOkText;

        return modalRef.result;
    }

    public showOffline(): Promise<boolean> {
        // if (!this.isOfflineAlertOpen) {
        //   this.isOfflineAlertOpen = true;
        //   const modalRef = this.modalService.open(OfflineDetectedDialogComponent, {});
        //   return modalRef.result;
        // }
        return Promise.resolve(true);
    }

    public showTimeoutWarning() {
        this.timeoutWarningModalRef = null;
        const alert = {
            title: 'Session Idle on Other Tab',
            message: `Your session from another tab has been inactive for an
      extended period of time. To prevent being logged out, select the
      inactive tab and indicate that you want to continue the session.`
        };

        this.timeoutWarningModalRef = this.modalService.open(AlertDialogComponent, { size: 'lg', centered: true });
        this.timeoutWarningModalRef.componentInstance.title = alert.title;
        this.timeoutWarningModalRef.componentInstance.message = alert.message;
        this.timeoutWarningModalRef.componentInstance.btnOkText = 'OK';
    }

    public closeTimeoutWarning() {
        if (this.timeoutWarningModalRef) {
            this.timeoutWarningModalRef.close();
            this.timeoutWarningModalRef = null;
        }
    }
}
